import React from 'react'

const Cookies = () => {
  return (
    <div className="globalmainstyles">
      Cookies
    </div>
  )
}

export default Cookies
